/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * "No thanks": an optional free-text reason of at most 500 characters, and an optional contact. No contact
 * is needed to pass (TXN-3475); one the resident leaves (an email or phone) needs name, email and
 * `consent_accepted` true (422 otherwise), as on a decline. With a contact on file it is ignored.
 * @export
 * @interface HomeownershipPassRequest
 */
export interface HomeownershipPassRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipPassRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipPassRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipPassRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipPassRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipPassRequest
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipPassRequest
     */
    consentAccepted?: boolean;
}

/**
 * Check if a given object implements the HomeownershipPassRequest interface.
 */
export function instanceOfHomeownershipPassRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function HomeownershipPassRequestFromJSON(json: any): HomeownershipPassRequest {
    return HomeownershipPassRequestFromJSONTyped(json, false);
}

export function HomeownershipPassRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipPassRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'consentAccepted': !exists(json, 'consent_accepted') ? undefined : json['consent_accepted'],
    };
}

export function HomeownershipPassRequestToJSON(value?: HomeownershipPassRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'reason': value.reason,
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'consent_accepted': value.consentAccepted,
    };
}

